export default __webpack_public_path__ + "static/media/6.39f50bd9.jpg";